import Blockly from 'blockly/browser'
import { mapSireniaPrimitiveToBlocklyPrimitive } from './Util'
import { getXmlEscaper } from './Blocklify/BlocklifyUtil'

const escapeXml = getXmlEscaper()

function registerFieldsCategoryCallback(workspace, fieldNames) {
  function callback(workspace) {
    if (Blockly.Blocks['sirenia_api_autofield']) {
      return fieldNames.map(fieldName => {
        let blockText =
          '<xml>' +
          '<block type="sirenia_api_autofield">' +
          `<field name="fieldName">${escapeXml(fieldName)}</field>` +
          '</block>' +
          '</xml>'
        return Blockly.Xml.textToDom(blockText).firstChild
      })
    }
    return []
  }

  workspace.registerToolboxCategoryCallback('FIELDS_CATEGORY', callback)
}

function registerFlowsCategoryCallback(workspace, flows, categoryName) {
  function callback(workspace) {
    return flows
      .filter(flow => flow.type === 'ACTION')
      .map(flow => {
        const argAttrs = flow.inputs.map(
          (input, idx) =>
            `arg${idx}="${input.name}|${mapSireniaPrimitiveToBlocklyPrimitive(input.type) || ''}"`
        )
        const blockText =
          '<xml>' +
          `<block type="javascript_expression_statement">
            <value name="ignoredInput">
              <block type="sirenia_api_flow_run">
                <field name="FLOW_NAME">${escapeXml(flow.name)}</field>
                <mutation ${argAttrs.join(' ')}></mutation>
              </block>
            </value>
          </block>` +
          '</xml>'
        return Blockly.Xml.textToDom(blockText).firstChild
      })
  }
  workspace.registerToolboxCategoryCallback(categoryName, callback)
}

function registerInputsCategoryCallback(workspace, inputs) {
  function callback(workspace) {
    return inputs.map(input => {
      let blockText =
        '<xml>' +
        `<block type="sirenia_api_flow_input">
          <mutation outputtype="${mapSireniaPrimitiveToBlocklyPrimitive(input.type)}"></mutation>
          <field name="INPUT_NAME">${escapeXml(input.name)}</field>
        </block>` +
        '</xml>'
      return Blockly.Xml.textToDom(blockText).firstChild
    })
  }

  workspace.registerToolboxCategoryCallback('INPUTS_CATEGORY', callback)
}

function registerModulesCategoryCallback(workspace, flows, categoryName) {
  function callback(workspace) {
    return flows
      .filter(flow => flow.type === 'MODULE')
      .map(module => {
        const blockText =
          '<xml>' +
          `<block type="javascript_variable_declaration" id="the-block">
            <statement name="declarations">
              <block type="javascript_variable_assign">
                <value name="value">
                  <block type="sirenia_api_flow_include">
                    <mutation not-editable="true"></mutation>
                    <field name="MODULE_NAME" editable="false">${escapeXml(module.name)}</field>
                  </block>
                </value>
              </block>
            </statement>
          </block>` +
          '</xml>'
        return Blockly.Xml.textToDom(blockText).firstChild
      })
  }
  workspace.registerToolboxCategoryCallback(categoryName, callback)
}

export default {
  registerFieldsCategoryCallback,
  registerFlowsCategoryCallback,
  registerInputsCategoryCallback,
  registerModulesCategoryCallback
}
